import { forPhoneOnly as s, forTabletUp as c, forTabletOnly as b, forDesktopUp as e } from "./mediaQueries.js";
function d(n, i, f) {
  if (!Array.isArray(i))
    return o(n, i, f);
  if (i.length === 2) {
    const [t, r] = i;
    return s(o(n, t, f)) + c(o(n, r, f));
  }
  if (i.length === 3) {
    const [
      t,
      r,
      l
    ] = i;
    return s(o(n, t, f)) + b(o(n, r, f)) + e(o(n, l, f));
  }
  throw new Error(
    `Received unknown responsiveValue: ${JSON.stringify(i)}`
  );
}
function o(n, i, f) {
  return u(i) ? `${n}: ${i}${f ? " !important" : ""};` : "";
}
function u(n) {
  return !!(n || n === 0);
}
export {
  d as responsiveToCss
};
